<!-- =========================================================================================
    File Name: StatisticsCard.vue
    Description: Statistics card component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <vx-card class="overflow-hidden">
    <div slot="no-body">
      <div
        class="p-6 pb-base"
        :class="{
          'flex justify-between flex-row-reverse items-center': iconRight
        }"
      >
        <img
          v-if="icon == 'Gas'"
          class="p-3 inline-flex rounded-full text-primary"
          :src="require('@/assets/images/flame.svg')"
          style="--color_fill: #FFF; width: 46px;"
          :style="{ background: `rgba(var(--vs-${color}),.15)` }"
        />
        <img
          v-if="icon == 'Electricity'"
          class="p-3 inline-flex rounded-full text-primary"
          :src="require('@/assets/images/plug.svg')"
          style="--color_fill: #FFF; width: 46px;"
          :style="{ background: `rgba(var(--vs-${color}),.15)` }"
        />
        <div class=" statistic" v-for="stat in stats" :key="stat.value">
          <h2
            class="font-bold"
            v-if="$store.state.usageSettings.unity == 'Money'"
          >
            <money-format :value="stat.value" locale="nl" currency-code="EUR" />
          </h2>

          <h2
            class="font-bold"
            v-if="$store.state.usageSettings.unity == 'Usage'"
          >
            {{ stat.value | commaDecimal }} {{ $t(`Productunity.${icon}`) }}
          </h2>
          <span>{{ stat.title }}</span>
          <span
            class="mb-1 mt-4 ml-2"
            :class="{
              'text-success': statisticPercentage <= 0,
              'text-danger': statisticPercentage > 0
            }"
            v-if="false && statisticPercentage"
          >
            {{ Math.abs(statisticPercentage) }}%
            {{ `${statisticPercentage > 0 ? "meer" : "minder"}` }} verbruikt dan
            in de periode {{ getPeriod(-1) | date }} ({{ statisticPrevious }})
          </span>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
import _color from "@/assets/utils/color.js";
import moment from "moment";
import MoneyFormat from "vue-money-format";

export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    stats: {
      required: true
    },
    color: {
      type: String,
      default: "primary"
    },
    colorTo: {
      type: String
    },
    // chartType: {
    //     type: String,
    //     default: 'line-chart',
    // },
    type: {
      type: String,
      default: "line"
    },
    iconRight: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    themePrimaryColor() {
      this.$refs.apexChart.updateOptions({
        theme: { monochrome: { color: this.getHex(this.color) } }
      });
    }
  },
  computed: {
    themePrimaryColor() {
      return this.$store.state.themePrimaryColor;
    }
  },
  filters: {
    date: function(usageSettings) {
      let fromDate = moment(usageSettings[0]);
      let toDate = moment(usageSettings[1]);

      let calendarSettings = {
        sameDay: "[Vandaag]",
        lastDay: "[Gisteren]",
        lastWeek: "dddd LL",
        sameElse: "dddd LL"
      };

      let fromDateCalendar = fromDate
        .locale("nl")
        .calendar(null, calendarSettings);

      let toDateCalendar = toDate.locale("nl").calendar(null, calendarSettings);

      return fromDate.isSame(toDate)
        ? fromDateCalendar
        : `${fromDateCalendar} - ${toDateCalendar}`;
    },
    commaDecimal: function(value) {
      return value.toString().replace(".", ",");
    }
  },
  components: {
    MoneyFormat
  },
  methods: {
    getHex(color) {
      if (_color.isColor(color)) {
        let rgb = window
          .getComputedStyle(document.documentElement)
          .getPropertyValue(`--vs-${color}`);
        rgb = rgb.split(",");
        return (
          "#" +
          (
            (1 << 24) +
            (Number(rgb[0]) << 16) +
            (Number(rgb[1]) << 8) +
            Number(rgb[2])
          )
            .toString(16)
            .slice(1)
        );
      }
      return color;
    },
    gradientToColor(color) {
      let gradientToColors = {
        primary: "#A9A2F6",
        success: "#55DD92",
        warning: "#ffc085",
        danger: "#F97794"
      };

      return gradientToColors[color]
        ? gradientToColors[color]
        : gradientToColors["primary"];
    },
    getPeriod(shift) {
      let periodDuration = moment(this.$store.state.usageSettings.toDate).diff(
        moment(this.$store.state.usageSettings.fromDate)
      );
      periodDuration += 1000 * 60 * 60 * 24 * 1; //add 1 day

      if (shift < 0) {
        return [
          moment(this.$store.state.usageSettings.fromDate)
            .subtract(periodDuration)
            .format("YYYY-MM-DD"),
          moment(this.$store.state.usageSettings.toDate)
            .subtract(periodDuration)
            .format("YYYY-MM-DD")
        ];
      } else {
        return [
          moment(this.$store.state.usageSettings.fromDate)
            .add(periodDuration)
            .format("YYYY-MM-DD"),
          moment(this.$store.state.usageSettings.toDate)
            .add(periodDuration)
            .format("YYYY-MM-DD")
        ];
      }
    }
  }
};
</script>
<style scoped>
.statistic h2,
.statistic h5 {
  display: inline-block;
}
.statistic span {
  display: block;
}
.statistic:first-of-type {
  padding-bottom: 30px;
}
</style>
